import React from 'react';
import { Box, Divider, Text } from '@wix/design-system';
import { AiSparkleIcon } from './AiSparkleIcon';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export const BusinessNameTooltip = _ref => {
  let name = _ref.name;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const reasoning = name.reasoning ?? '';
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "16px",
    padding: "20px",
    dataHook: "business-name-tooltip"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP1",
    verticalAlign: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0
  }, /*#__PURE__*/React.createElement(AiSparkleIcon, null)), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, reasoning)), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, t('domain_search_gate.bng_results.names_section.tooltip.explore_cta')));
};
//# sourceMappingURL=BusinessNameTooltip.js.map